<template>
  <div class="section section--slide newsletters">
    <h2 class="section__heading newsletters__heading">{{ recentNewsHeading }}</h2>
    <splide :options="newsletterOptions">
      <splide-slide v-for="newsletter in content">
        <nuxt-link class="newsletter"
           :key="newsletter.title.en"
           :to="localePath(`/news/${newsletter.slug.current}`)">
          <img :src="$urlFor(newsletter.thumb.asset.url, 700)"
                    :alt="locale === 'en' ? newsletter.thumbAlt.en : newsletter.thumbAlt.jp"
                    class="newsletter__image"
                    loading="lazy"
									 	:style="`object-position:${newsletter.thumbAlignment || 'middle'}`"
                    :height="newsletter.thumb.asset.metadata.dimensions.height"
                    :width="newsletter.thumb.asset.metadata.dimensions.width" />
          <div class="newsletter__details">
            <h3 class="newsletter__title">{{ locale === 'en' ? newsletter.title.en : newsletter.title.jp }}</h3>
            <h5 class="newsletter__date">{{ formatDate(newsletter.publishedAt, newsletter._createdAt, locale) }}</h5>
          </div>
        </nuxt-link>
      </splide-slide>
    </splide>
    <NuxtLink to="/news" class="block-link block-link--news">{{newsLink}} &rarr;</NuxtLink>
  </div>
</template>

<script setup>
import { useI18n, useLocalePath } from '#imports'
import { computed } from "vue"
import { Splide, SplideSlide } from '@splidejs/vue-splide';
import '@splidejs/splide/dist/css/themes/splide-default.min.css';
const { locale } = useI18n()
const localePath = useLocalePath()
const props = defineProps({
  content: Object,
	text: Object
})
function formatDate(published, created, lang) {
	const retrievedDate = computed(() => published !== null ? published : created)
	const options = { day: 'numeric', month: 'long', year: 'numeric', }
	return new Date(retrievedDate.value).toLocaleDateString(lang, options)
}
const newsletterOptions = {
  rewind : false,
  drag: 'free',
  perMove: '1',
  perPage: '1',
  autoWidth: true,
  width  : '100%',
  gap    : 0,
  snap    :  true,
  lazyLoad: true,
  pagination: false,
  breakpoints: {
    767: {
      perPage: 1
    }
  }
}
let recentNewsHeading
let newsLink
if(props.text.title !== null){
	recentNewsHeading	= computed(() => locale.value === 'en' ? props.text.title.en : props.text.title.jp )
} else {
	recentNewsHeading	= computed(() => locale.value === 'en' ? 'News' : 'ニュース' )
}
if(props.text.newsLinkText.en !== null) {
	newsLink = computed(() => locale.value === 'en' ? props.text.newsLinkText.en : props.text.newsLinkText.jp)
} else {
	newsLink = computed(() => locale.value === 'en' ? 'See all of our news' : 'すべてのニュースをご覧')
}
</script>

<style lang="scss" scoped>
@use '@/assets/sass/variables.scss' as v;
.newsletters {
  max-width: 100%;
  padding: 1rem 0;
  position: relative;
  @include v.respond-to('small') {
    padding: 3rem 0 3rem 3rem;
  }
  &__heading {
    margin: 0 0 0.75rem 1rem;
    @include v.respond-to('small') {
      margin: 0 0 2rem 0;
    }
  }
	.newsletter {
		display: flex;
		flex-direction: column;
		margin: 0 0 0 1rem;
		min-width: 18rem;
		max-width: 80vw;
		text-decoration: none;
		transition: 0.3s;
		@include v.respond-to('small') {
			flex-direction: row;
			margin: 0 3rem 1rem 0;
			max-width: 25rem;
		}
		&:hover {
			background-color: v.$black;
			color: v.$white;
			transition: 0.3s;
			.newsletter__date {
				color: v.$white;
				transition: 0.3s;
			}
		}
		&__image {
			height: 10rem;
			object-fit: cover;
			width: 100%;
			aspect-ratio: 16 / 9;
		}
		&__details {
			min-height: 6.25rem;
		}
		&__date {
			color: v.$mainColour;
			font-size: v.$font-size;
			font-weight: 500;
			margin: 0 0 0 0;
			padding: 0 1rem 0.5rem 1rem;

		}
		&__title {
			font-family: var(--font);
			font-size: v.$font-size;
			margin: 0.5rem 1rem 1rem 1rem;
			padding: 0;
		}
	}
	.block-link--news {
		margin: 0.5rem 0 0 1rem;
		font-size: v.$font-size-med;
		@include v.respond-to('small') {
			margin: 0.5rem 0 0 0;
		}
	}
}
</style>
